import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  EpimsBankDetailStoreActions,
  EpimsBankDetailStoreSelectors,
  EpimsBankDetailStoreReducer,
} from './index';
import { EpimsBankDetailDto } from '@cradua/data';

@Injectable()
export class EpimsBankDetailFacade {
  constructor(
    private store: Store<
      EpimsBankDetailStoreReducer.EpimsBankDetailPartialState
    >
  ) {}

  communityRecord$ = this.store.select(
    EpimsBankDetailStoreSelectors.getSelected
  );
  communityRecordError$ = this.store.select(
    EpimsBankDetailStoreSelectors.getEpimsBankDetailError
  );

  getselected() {
    return this.store.select(EpimsBankDetailStoreSelectors.getSelected);
  }

  get isLoadingEpimsBankDetail() {
    // this.store.dispatch(EpimsBankDetailStoreActions.loadEpimsBankDetail({id}));
    return this.store.select(
      EpimsBankDetailStoreSelectors.loadingEpimsBankDetail
    );
  }

  loadEpimsBankDetail(id) {
    this.store.dispatch(
      EpimsBankDetailStoreActions.loadEpimsBankDetail({ id })
    );
  }

  get getAllBankDetailById() {
    return this.store.select(
      EpimsBankDetailStoreSelectors.getAllEpimsBankDetail
    );
  }

  addEpimsBankDetail(newEpimsBankDetail: EpimsBankDetailDto[]) {
    this.store.dispatch(
      EpimsBankDetailStoreActions.addEpimsBankDetail({ newEpimsBankDetail })
    );
  }

  updateEpimsBankDetail(updateEpimsBankDetail: EpimsBankDetailDto[]) {
    this.store.dispatch(
      EpimsBankDetailStoreActions.updateEpimsBankDetail({
        updateEpimsBankDetail,
      })
    );
  }

  removeEpimsBankDetail(ids: string[]) {
    this.store.dispatch(
      EpimsBankDetailStoreActions.removeEpimsBankDetail({ ids })
    );
  }
}
